
import React, { useState } from "react";
import axios from "axios";

const AdminPage = () => {
  const [createdUsers, setCreatedUsers] = useState([]);
  const [titles, setTitles] = useState({
    title1: "",
    renew: "",
    title3: "",
  });

  const [loading, setLoading] = useState({
    title1: false,
    renew: false,
    title3: false,
  });
  const [renewEmail, setRenewEmail] = useState('');
  const [renewMonths, setRenewMonths] = useState('1');
  
  // API Endpoints for each field
  const API_BASE = "https://api-haky67ykya-uc.a.run.app";

const endpoints = {
  title1: `${API_BASE}/create`,
  renew: `${API_BASE}/renew`,
  title3: `${API_BASE}/trial`,
};
  // const endpoints = {
  //   title1: "http://127.0.0.1:5001/paralight-9bf8e/us-central1/api/create",
  //   renew: "http://127.0.0.1:5001/paralight-9bf8e/us-central1/api/renew",
  //   title3: "http://127.0.0.1:5001/paralight-9bf8e/us-central1/api/trial",
  // };

  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const correctPassword = 'Paralight1612'
  ; // Change this to your actual password


  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    console.log(correctPassword)
    if (password === correctPassword) {
      setAuthenticated(true);
    } else {
      alert("❌ Incorrect password! Try again.");
      setPassword(""); // Reset input field
    }
  };

  // 🔹 Show Password Entry Screen if Not Authenticated
  
  // Function to handle input changes
  const handleChange = (e) => {
    setTitles({ ...titles, [e.target.name]: e.target.value });
  };
  const sendEmailsToAPI = async (fieldName) => {
    setLoading((prev) => ({ ...prev, [fieldName]: true }));
  
    try {
      let payload;
  
      if (fieldName === 'renew') {
        if (!renewEmail.includes('@') || !renewMonths) {
          alert("⚠️ Please enter a valid email and number of months.");
          setLoading((prev) => ({ ...prev, [fieldName]: false }));
          return;
        }
  
        payload = {
          email: renewEmail.trim().toLowerCase(),
          months: parseInt(renewMonths),
        };
      } else {
        const emailList = titles[fieldName]
          .split(",")
          .map((email) => email.trim().toLowerCase())
          .filter((email) => email.includes("@"));
  
        if (emailList.length === 0) {
          alert(`⚠️ Please enter at least one valid email for ${fieldName}.`);
          setLoading((prev) => ({ ...prev, [fieldName]: false }));
          return;
        }
  
        payload = { emails: emailList };
      }
  
      const response = await axios.post(endpoints[fieldName], payload);
  
      if (response.data.success) {
        alert(`✅ Request successful for ${fieldName}!`);
        if (fieldName !== 'renew') {
          setTitles((prev) => ({ ...prev, [fieldName]: "" }));
          setCreatedUsers(response.data.users || []);
        } else {
          setRenewEmail('');
          setRenewMonths('');
        }
      } else {
        throw new Error(response.data.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error:", error);
      alert(`❌ Error in ${fieldName} request. Check console for details.`);
    } finally {
      setLoading((prev) => ({ ...prev, [fieldName]: false }));
    }
  };
  
  // Function to send emails to API
  // const sendEmailsToAPI = async (fieldName) => {
  //   const emailList = titles[fieldName]
  //     .split(",")
  //     .map((email) => email.trim().toLowerCase())
  //     .filter((email) => email.includes("@"));
  
  //   if (emailList.length === 0) {
  //     alert(`⚠️ Please enter at least one valid email for ${fieldName} before submitting.`);
  //     return;
  //   }
  
  //   setLoading((prev) => ({ ...prev, [fieldName]: true })); // Start loading
  
  //   try {
  //     const response = await axios.post(endpoints[fieldName], { emails: emailList });
  
  //     if (response.data.success) {
  //       alert(`✅ Users created successfully for ${fieldName}!`);
  //       setTitles((prev) => ({ ...prev, [fieldName]: "" })); // Reset input field
  //       setCreatedUsers(response.data.users); // Save created users to state
  //     } else {
  //       throw new Error(response.data.message || "Unknown error");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert(`❌ Error sending emails for ${fieldName}. Check console for details.`);
  //   } finally {
  //     setLoading((prev) => ({ ...prev, [fieldName]: false })); // Stop loading
  //   }
  // };
  if (!authenticated) {
    return (
      <div style={styles.container}>
        <h2 style={styles.heading}>Admin Access Required</h2>
        <form onSubmit={handlePasswordSubmit} style={styles.form}>
          <input
            type="password"
            placeholder="Enter Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Enter</button>
        </form>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Admin Page</h2>
      <div style={styles.form}>
      <input
  type="email"
  placeholder="Enter email to renew"
  value={renewEmail}
  onChange={(e) => setRenewEmail(e.target.value)}
  style={styles.textarea}
/>
<input
  type="number"
  placeholder="Number of months to renew"
  value={renewMonths}
  onChange={(e) => setRenewMonths(e.target.value)}
  style={styles.textarea}
/>
<button
  style={loading.renew ? styles.buttonDisabled : styles.button}
  onClick={() => sendEmailsToAPI("renew")}
  disabled={loading.renew}
>
  {loading.renew ? "Renewing..." : "Renew Subscription"}
</button>

        {/* <textarea
          name="title1"
          placeholder="Enter emails to Create Users (comma separated)"
          value={titles.title1}
          onChange={handleChange}
          style={styles.textarea}
        />
        <button
          style={loading.title1 ? styles.buttonDisabled : styles.button}
          onClick={() => sendEmailsToAPI("title1")}
          disabled={loading.title1}
        >
          {loading.title1 ? "Saving..." : "Create Users"}
        </button>

        <textarea
          name="renew"
          placeholder="Enter emails to Renew Subscription (comma separated)"
          value={titles.renew}
          onChange={handleChange}
          style={styles.textarea}
        />
        <button
          style={loading.renew ? styles.buttonDisabled : styles.button}
          onClick={() => sendEmailsToAPI("renew")}
          disabled={loading.renew}
        >
          {loading.renew ? "Saving..." : "Renew Subscription"}
        </button>

        <textarea
          name="title3"
          placeholder="Enter emails for Trial Period (comma separated)"
          value={titles.title3}
          onChange={handleChange}
          style={styles.textarea}
        />
        <button
          style={loading.title3 ? styles.buttonDisabled : styles.button}
          onClick={() => sendEmailsToAPI("title3")}
          disabled={loading.title3}
        >
          {loading.title3 ? "Saving..." : "Trial Period"}
        </button> */}
      </div>
      <div style={styles.resultsContainer}>
  <h3>Created Users</h3>
  {createdUsers.length > 0 ? (
    <ul>
      {createdUsers.map((user, index) => (
        <li key={index} style={styles.userItem}>
          <strong>Email:</strong> {user.email} | <strong>Password:</strong> {user.password} | <strong>User ID:</strong> {user.userId}
        </li>
      ))}
    </ul>
  ) : (
    <p>No users created yet.</p>
  )}
</div>
    </div>
  );
};

// 🔹 Updated Styles Object
const styles = {
  input:{
    height: '40px',
    marginBottom: '50px'
  },
  container: {
    maxWidth: "500px",
    margin: "50px auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  heading: {
    color: "#333",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  textarea: {
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "16px",
    height: "80px",
    resize: "none",
  },
  button: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background 0.3s",
    marginBottom: "10px",
  },
  buttonDisabled: {
    backgroundColor: "#ccc",
    color: "#666",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "not-allowed",
    marginBottom: "10px",
  },
  resultsContainer: {
    marginTop: "20px",
    padding: "10px",
    backgroundColor: "#f8f9fa",
    borderRadius: "5px",
  },
  userItem: {
    padding: "5px",
    borderBottom: "1px solid #ddd",
  },
};

export default AdminPage;
